import React from 'react'

import styled from 'styled-components'

import CharacterReferenceDetails from '../CharacterReferenceDetails'
import EmptyWrapper from '../../../src/components/EmptyWrapper'

import { PiIdentificationCardThin } from 'react-icons/pi'

const CharacterReferences = ({
  characterReferences = [],
  editIcon,
  handleEditModal,
}) => {
  return (
    <>
      <Header>
        <Title>Character References</Title>
        <EditIcon src={editIcon} alt="icon" onClick={handleEditModal} />
      </Header>
      {characterReferences !== null && characterReferences.length > 0 ? (
        <Article>
          <ul className="character__references">
            {characterReferences?.map((cr) => (
              <li key={cr.id}>
                <PiIdentificationCardThin className="icon" />
                <CharacterReferenceDetails
                  crName={cr.crName || cr.name}
                  crEmail={cr.crEmail || cr.email}
                  crPhone={cr.crPhone || cr.phone}
                  id={cr.id}
                  withActionButtons={false}
                />
              </li>
            ))}
          </ul>
        </Article>
      ) : (
        <EmptyWrapper maxHeight="100%" marginBottom="1rem" marginTop="1rem">
          You have no character references.
        </EmptyWrapper>
      )}
    </>
  )
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

const EditIcon = styled.img`
  color: #31374f;
  cursor: pointer;
`

const Title = styled.h4`
  font-weight: 600;
  font-size: 16px;
  color: #31374f;
  font-size: inherit;
`

const Article = styled.article`
  width: 100%;
  padding-right: 20px;
  font-family: inherit;

  .character__references {
    list-style-type: none;
    margin: 0.5rem 0;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    li {
      display: flex;
      gap: 0.5rem;

      .icon {
        margin-top: 2px;
      }
    }
  }
`

export default CharacterReferences
